import { render, staticRenderFns } from "./TapestryScoresByScenario.vue?vue&type=template&id=f2e5e24c"
import script from "./TapestryScoresByScenario.vue?vue&type=script&lang=ts"
export * from "./TapestryScoresByScenario.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports